// Constants
import { GIL_API_CHANNEL } from 'constants/api.constants';
// Utilities
import { getCheckoutIdFromUrl } from 'utils/browser-url.utils';

const CHECKOUT_ORDER_DATA_SERVICE_ENDPOINT = {
    endpoint: 'gil-api-mng-amz-ldg/v1/checkout/orders/:checkoutId',
    pathParams: {
      checkoutId: getCheckoutIdFromUrl(),
    },
    queryParams: {
      expand: 'CUSTOMER_DATA',
    },
    ...GIL_API_CHANNEL,
  },
  SAVE_REDIRECT_DATA_SERVICE_ENDPOINT = {
    endpoint: 'gil-api-mng-amz-ldg/v1/checkout/orders/:checkoutId/redirect-data',
    pathParams: {
      checkoutId: getCheckoutIdFromUrl(),
    },
    params: { tmxCallDone: true },
    ...GIL_API_CHANNEL,
  };

export { CHECKOUT_ORDER_DATA_SERVICE_ENDPOINT, SAVE_REDIRECT_DATA_SERVICE_ENDPOINT };
